import styled from 'styled-components'

export const TableContainer = styled.div`
  width: 100%;
  min-height: 150px;
  margin-top: 20px;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 16px;
  padding: 12px 16px;
  background-color: #080808;
  border-bottom: 2px solid #191919;
  font-weight: 600;
  color: #ffffff;
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 16px;
  padding: 12px 16px;
  border-bottom: 1px solid #272727;
  align-items: center;
  
  &:nth-child(even) {
    background-color: #000000;
  }
  
  &:nth-child(odd) {
    background-color: #030303;
  }
`;

export const UserColumn = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Avatar = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
`;

export const DefaultAvatar = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #1d1e1e;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  font-weight: bold;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Nickname = styled.span`
  font-weight: 500;
  color: #ffffff;
  text-transform: lowercase;
`;

export const VerificationIcon = styled.i`
  font-size: 16px;
  
  &.verified {
    color: #28a745;
  }
  
  &.not-verified {
    color: #dc3545;
  }
`;

export const AmountColumn = styled.div`
  text-align: right;
  font-weight: 500;
  color: #7bcb16;
`;

export const DateColumn = styled.div`
  text-align: right;
  color: #6c757d;
`;

export const ActionColumn = styled.div`
  text-align: center;
`;

export const ActionButton = styled.button`
  background: transparent;
  border: 1px solid #6c757d;
  border-radius: 4px;
  padding: 3px 12px;
  cursor: pointer;
  color: #6c757d;
  font-size: 14px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #6c757d;
    color: white;
  }
`;
